<template>
  <div class="mastery-input-container relative">
    <label class="text-sm font-medium text-primary" :for="inputId">{{ label }}</label>
    <input
      :id="inputId"
      v-model="model"
      :type="displayedType"
      :class="{ error: showError, filled: field.length > 0 }"
      :placeholder="placeholder"
      @keyup.enter="$emit('enter')"
      @input="dirtyInput = true"
    >
    <button
      v-if="type === 'password'"
      class="button-reset icon-small"
      @click="showPassword = !showPassword"
    >
      <icon
        :name="passwordIcon"
      ></icon>
    </button>
    <span v-if="showError" class="text-sm font-regular text-error">
      {{ error }}
    </span>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon';

export default {
  components: {
    Icon,
  },
  props: {
    error: {
      type: String,
    },
    field: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: 'text',
    },
  },
  emits: ['enter', 'inputChange'],
  data() {
    return {
      showPassword: false,
      dirtyInput: false,
    };
  },
  computed: {
    displayedType () {
      if (this.type === 'password') {
        return this.showPassword ? 'text' : 'password';
      }
      return this.type;
    },
    model: {
      get() {
        return this.field;
      },
      set(value) {
        this.$emit('inputChange', value);
      },
    },
    passwordIcon() {
      if (this.showError) {
        return 'error-info';
      }
      return this.showPassword ? 'eye-on' : 'eye-off';
    },
    inputId() {
      return `${this.label.toLowerCase().split('').join('-')}-input`;
    },
    showError() {
      return this.error && !this.dirtyInput;
    },
  },
  watch: {
    error(newValue) {
      if (newValue) {
        this.dirtyInput = false;
      }
    },
  },

};
</script>

<style lang="scss" scoped>
.mastery-input-container {
  margin-bottom: rem-calc(16);
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  input {
    border: 1px solid var(--border-primary);
    border-radius: var(--radius-md);
    box-sizing: border-box;
    box-shadow: 0px 1px 2px 0px rgba(10, 13, 18, 0.05);
    width: 100%;

    &::placeholder {
      color: var(--text-placeholder);
    }

    &.error {
      border-color: #e36048;
    }

    &:focus + label, &.error + label, &.filled + label {
      color: #001c74;
      font-size: rem-calc(10);
      font-weight: $semi-bold;
      top: rem-calc(-5);
      left: rem-calc(12);
      background: white;
      padding: 0 rem-calc(4);
      z-index: 10;

      @include focus-not-visible {
        outline: none;
      }
    }

    &.error + label {
      color: #e36048;
    }
  }
}

.icon-small {
  position: absolute;
  right: rem-calc(12);
  top: rem-calc(36);
  color: var(--text-secondary);
}

.relative {
  position: relative;
}
</style>
